import { initializeApp } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBKyBRWIKDizFK73wcoypJbZBuV5M3hjfw",
  authDomain: "physiokia-6f692.firebaseapp.com",
  projectId: "physiokia-6f692",
  storageBucket: "physiokia-6f692.firebasestorage.app",
  messagingSenderId: "886186188608",
  appId: "1:886186188608:web:0443244a1b24419a7964a5",
  measurementId: "G-F2SMNMKXT0",
};

if (!firebaseConfig.apiKey) {
  // Warn in dev so environment is configured before hitting Firebase
  console.warn(
    "Firebase config is missing. Set REACT_APP_FIREBASE_* env vars."
  );
}

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

// Enable persistent authentication
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error("Failed to set auth persistence:", error);
});
